export const alarmTypesEnum = {
  GATEWAY_OFFLINE: 'GATEWAY_OFFLINE',
  GATEWAY_CONFIGURATION_ERROR_UPDATING: 'GATEWAY_CONFIGURATION_ERROR_UPDATING',
} as const

export type AlarmTypesEnum = (typeof alarmTypesEnum)[keyof typeof alarmTypesEnum]

export type AlarmTypes = AlarmTypesEnum